<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" :disabled="multiple"
            v-preventReClick @click="handleDelete">删除</el-button>

          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData"
            v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <el-button type="primary" class="btn primary" :disabled="multiple" v-preventReClick
            @click="toPayment">转付款</el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" stripe
        :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="no" label="发票登记单号" width="170">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierName" width="160" label="供应商" />
        <el-table-column show-overflow-tooltip prop="categoryName" width="100" label="开票类型" />
        <el-table-column show-overflow-tooltip width="200" prop="acceptInStockNos" label="采购入库单号">
          <template slot-scope="scope">
            {{ scope.row.acceptInStockNos?scope.row.acceptInStockNos:'-' }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="200" prop="acceptOutStockNos" label="采购退货单号">
          <template slot-scope="scope">
            {{ scope.row.acceptOutStockNos?scope.row.acceptOutStockNos:'-' }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="160" prop="purchaseDistributeNo" label="配送单号">
          <template slot-scope="scope">
            {{ scope.row.purchaseDistributeNo?scope.row.purchaseDistributeNo:'-' }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="stateName" label="状态" />
        <el-table-column show-overflow-tooltip prop="createdUserName" label="发起人" />
        <el-table-column width="120" prop="createdTime" label="创建时间">
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.createdTime))
            }}</template>
        </el-table-column>
        <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center"
          prop="approverNames">
          <template slot-scope="scope">
            {{ scope.row.approverNames?scope.row.approverNames:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions"
              @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.remark?scope.row.remark:'-' }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text"
              v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <el-button v-else-if="
              scope.row.status != 1 &&
              scope.row.status != 2 &&
              tableAcl.indexOf('Edit') != -1
            " type="text" v-preventReClick @click="handleUpdate(scope.row)"
              class="margin-left20 color-blue">编辑</el-button>
            <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
            <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick
              @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
            <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetBillRegisters,
  RemoveBillRegister,
  GetAcceptInStocks,
  ExportBillRegister,
  GetAcceptOutStocks,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import { ApproveStatusOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      GetDatasAction: GetBillRegisters,
      RemoveAction: RemoveBillRegister,
      exportAction: ExportBillRegister,
      // PrintAction: GetAcceptInStockPrintData,
      editPath: "bill-register-edit",

      // ApproveStatusOptions: ApproveStatusOptions,
      filterOptions: [
        {
          name: "发票登记单号",
          type: "input",
          code: "keyWord",
        },
        {
          name: "供应商",
          type: "select",
          code: "supplierId",
          filterMethod: this.getSuppliers,
          data: [],
        },
        {
          name: "采购入库",
          type: "select",
          code: "acceptInStockId",
          filterMethod: this.getAcceptInStockList,
          data: [],
          labelName: "no",
        },
        {
          name: "采购退货",
          type: "select",
          code: "acceptOutStockId",
          filterMethod: this.getAcceptOutStockList,
          data: [],
          labelName: "no",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
        // {
        //   name: "流程状态",
        //   type: "select",
        //   code: "statuses",
        //   multiple: true,
        //   data: ApproveStatusOptions,
        // },
      ],
    };
  },
  methods: {
    getAcceptInStockList(keyWord) {
      return new Promise((resolve, reject) => {
        GetAcceptInStocks({ keyWord: keyWord, pageIndex: 1, pageSize: 100 }).then(
          (res) => {
            // this.acceptInStockList = res.returnData.data
            resolve(res.returnData.data);
          }
        );
      });
    },
    getAcceptOutStockList(keyWord) {
      return new Promise((resolve, reject) => {
        GetAcceptOutStocks({ keyWord: keyWord, pageIndex: 1, pageSize: 100 }).then(
          (res) => {
            // this.acceptInStockList = res.returnData.data
            resolve(res.returnData.data);
          }
        );
      });
    },

    toPayment() {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        this.$my_message("请选择数据", "warning");
        return;
      }

      let arr = this.multipleSelection.filter(
        (e) => e.status != 2 || (e.state != 1 && e.state != 2)
      );
      if (arr && arr.length > 0) {
        this.$my_message("请选择生效的可付款的发票登记单", "warning");
        return;
      }

      let supplierArr = this.multipleSelection.filter(
        (item) => item.supplierId != this.multipleSelection[0].supplierId
      );
      if (supplierArr && supplierArr.length > 0) {
        this.$my_message("只能选择同一个供应商的发票进行付款", "warning");
        return;
      }
      this.supplierId = this.multipleSelection[0].supplierId;
      this.supplierName = this.multipleSelection[0].supplierName;

      // this.paymentVisible = true
      this.$router.push({
        name: "PaymentEdit",
        params: {
          supplierId: this.supplierId,
          supplierName: this.supplierName,
          billRegisterArray: this.multipleSelection,
        },
      });
    },
  },
  mounted() { },
};
</script>

<style lang="scss" scoped></style>
